import React from 'react'
import { Row, Skeleton } from '@fs/zion-ui'
import { css } from '@emotion/core'

const headingWrapperCss = css`
  max-width: 200px;
`

const subheadingWrapperCss = css`
  max-width: 100px;
`

const searchSkeletonCss = css`
  width: 280px;
  height: 36px;
  border-radius: var(--border-radius-base);
`

const filterSkeletonCss = css`
  width: 120px;
  height: 36px;
  border-radius: var(--border-radius-base);
`

export default function SourceGridToolbarSkeleton(): JSX.Element {
  return (
    <>
      <div css={headingWrapperCss}>
        <Skeleton.H4 aria-hidden />
      </div>
      <div css={subheadingWrapperCss}>
        <Skeleton.H5 aria-hidden />
      </div>
      <Row alignY="middle" gutters="xs">
        <Skeleton.Base css={searchSkeletonCss} />
        <div growX />
        <Skeleton.Base css={filterSkeletonCss} />
      </Row>
    </>
  )
}
